import React from "react";

//
import Consumer from "../../../context/auth/AuthConsumer";

export default function AuthLoader({ children }) {
  return (
    <Consumer>
      {({ state : { loading } }) => (!loading ? children : <h1>Loading...</h1>)}
    </Consumer>
  );
}
